
export default {
  name: "Mission",
  props: {
    mission: Object,
  }
}
